import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import Button from '../elements/Button';
import Image from '../elements/Image';
import { Link } from 'react-router-dom';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class HeroFull extends React.Component {

  render() {
    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'hero section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'hero-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container-sm">
          <div className={innerClasses}>
            <div className="hero-content">
              <h1 className="mt-0 mb-16 reveal-from-top" data-reveal-delay="300">
                Ferekarpos U.G.
              </h1>
              <div className="container-xs">
                <p className="mt-0 mb-32 reveal-from-top" data-reveal-delay="400">
                The revolution in environmental friendly processing of waste and liquids cleaning based on electrolysis.
                </p>
                <div className="reveal-from-top" data-reveal-delay="500">
                  <Link to="/learn-more">
                    <Button color="primary" wideMobile>
                      Learn more
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
            <div className="hero-figure illustration-element-01 reveal-from-top" data-reveal-delay="500">
              <Image
                className="has-shadow"
                src={require('./../../assets/images/hero-media.jpg')}
                width={896}
                height={504}
                alt="Hero" />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

HeroFull.propTypes = propTypes;
HeroFull.defaultProps = defaultProps;

export default HeroFull;